/**
 *  Alaska: Editor
 *  Public: Book Consultation form
 *
 *  @version 1.0
 */

document.addEventListener("alpine:init", () => {
    Alpine.store("ConsultationModal", {
        open() {
            const store = Alpine.store("HtmlModal");

            store.load_html({
                controller: "Menu",
                action: "fetch",
                data: {
                    icon: "fa-comments",
                    title: "Book a Security Consultation",
                    menu: "book_consultation_form",
                },
                
            });
        },
    });

    Alpine.data("BookConsultationForm", () => ({
        state: "default",
        loading: false,

        form: {
            fullName: "",
            company: "",
            jobTitle: "",
            email: "",
            message: "",
            newsletter: false,
        },

        errors: {
            fullName: "",
            company: "",
            jobTitle: "",
            email: "",
            message: "",
        },

        get loadingState() {
            return this.loading;
        },

        get isDefault() {
            return this.state === "default" && !this.loading;
        },

        get isSuccess() {
            return this.state === "success" && !this.loading;
        },

        validate() {
            let valid = true;

            this.errors = {
                fullName: "",
                company: "",
                jobTitle: "",
                email: "",
                message: "",
            };

            if (this.form.fullName.trim() === "") {
                this.errors.fullName = "Full name is required";
                valid = false;
            }

            if (this.form.company.trim() === "") {
                this.errors.company = "Company name is required";
                valid = false;
            }

            if (this.form.jobTitle.trim() === "") {
                this.errors.jobTitle = "Job title is required";
                valid = false;
            }

            if (this.form.email.trim() === "") {
                this.errors.email = "Email address is required";
                valid = false;
            } else if (!this.form.email.includes("@")) {
                this.errors.email = "Invalid email address";
                valid = false;
            }

            if (this.form.message.trim() === "") {
                this.errors.message = "Message is required";
                valid = false;
            }
            return valid;
        },

        async submit() {
            if (!this.validate()) {
                Notification.render(
                    "Please fill out the required fields.", 
                    "error"
                );
                return;
            }

            this.loading = true;

            try {
                const response = await fetch("/alaska/public/", {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        controller: "Marketing",
                        action: "bookConsultation",
                        data: this.form,
                    })
                });

                const result = await response.json();
                console.log(result);

                // this.loading = false;

                if (result.type === "success") {
                    this.state = "success";
                    // this.reset();
                } else {
                    Notification.render(
                        result.message || "Unabled to submit your enquiry.", 
                        "error"
                    );
                }
            } catch (error) {
                console.error('Consultation form error:', error);
                Notification.render(
                    "Unabled to submit your enquiry. Please try again.", 
                    "error"
                );
            } finally {
                this.loading = false;
            }
        },
    }));
});
